export const listPeriodCyclePotential = [
  { label: "Monthly", value: 12 },
  { label: "Half-Yearly", value: 2 },
  { label: "Quaterly", value: 4 },
  { label: "Yearly", value: 1 },
  { label: "Custom", value: 0 },
];

export const WORKFLOW_STATUS = {
  DRAFT: "Draft",
  IN_REVIEW: "In Review",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
  REVISED: "Revised",
};

export const STAGE = {
  PLAN: "Plan",
  MONITORING: "Monitoring",
  COMPLETED: "Completed",
};

export const DATA_STATUS_VALUE = { ALL: "all", ONLY_ACTIVE: "onlyactive" };

export const DATA_STATUS_OPTIONS = [
  {
    value: DATA_STATUS_VALUE.ALL,
    label: "All",
  },
  {
    value: DATA_STATUS_VALUE.ONLY_ACTIVE,
    label: "Active only",
  },
];

export const DATA_IS_COMPLETE_IDP = {
  STRIP: "-",
  COMPLETED: "Completed",
  INCOMPLETED: "Incompleted",
};

export const ENUM_PROFILE_TYPE_IDP = {
  COMPETENCY: "Competency",
  SKILL: "Skill",
  EDUCATION: "Education",
  LEARNING: "Learning",
  CERTIFICATE: "Certificate",
};

export const ENUM_METHOD_IDP = {
  LEARNING: "Learning",
  OTHERS: "Others",
};

export const SECRET_KEY = "password_onehcm123";

export const LEARNING_EVENTS_STATUS_ATTENDANCE = {
  REGISTERED: "Register",
  COMPLETED: "Complete",
  CANCELLED: "Cancelled",
  DROPOUT: "Dropout",
  Confirm: "Confirm",
};

export const LEARNING_EVENTS_STATUS_PASS = {
  NONE: "None",
  PASS: "Pass",
};

export const OPTIONS_PARTICIPANT_TYPE = [
  {
    label: "General",
    value: "general",
  },
  {
    label: "IDP",
    value: "idp",
  },
];

export const LEARNING_COURSE_CONTENT_TYPE = {
  TEXT: "Text",
  QUESTIONARE: "Questionare",
  SUMMARY: "Summary",
  FILE: "File",
};

export const POLICY_TYPE = {
  LOAN: "Loan",
  ELIGIBILITY: "Eligibility",
  MEDICAL_CALCULATION: "Medical Calculation",
};

export const TABLE_NAME_ENUM = {
  LOANREQUEST: "loanrequest",
};

export const COLUMN_NAME_ENUM = {
  INTERESTTYPE: "interesttype",
};

export const INTEREST_TYPE_LOAN = {
  FLAT: "Flat",
  ANNUITY: "Annuity",
};

export const PROCESS_LOAN_BASED_ON = {
  LOAN_PERIOD: "Loan Period",
  LOAN_INSTALLMENT: "Loan Installment",
  ANNUITY: "Annuity",
};

export const PAGE_ONEHCM = {
  LOAN_REQUEST_ADD: "loan-request-add",
  LOAN_REQUEST_DETAIL: "loan-request-detail",
};

export const ACTION_WORKFLOW = {
  SUBMIT: "submit",
  APPROVE: "approve",
  REJECT: "reject",
};

export const WORKFLOW_TYPE = {
  LOAN_REQUEST: "Loan Request",
  FORCELOGOUT: "ForceLogout",
  FORCEUPDATE: "ForceUpdate",
  WORKER_ACTION_BULK: "Worker Action Bulk",
  SCHEDULE_EXCHANGE: "Schedule Exchange",
  LEAVE_REQUEST: "Leave Request",
};

export const DEFAULT_DATE_INVALID = {
  IN_VALID: "0001-01-01T00:00:00",
  DATE_SLASH: "0001/01/01",
};

export const TYPE_TABLE_SELECT = {
  CHECKBOX: "checkbox",
  RADIO: "radio",
};

export const FILE_TYPE = {
  HTML: "html",
  PDF: "pdf",
};

export const TENANT_ID = {
  ASABRI: "39681d6b-149a-4aaa-8768-18daf8e3e0bb",
  WCS: "393e9f552dd84c1c90b9b83189ebb81e",
  EJP: "ad8b3d0fb8954d20bc8b466727de0184",
  KBN: "f60db8115f414ac6b387ef594cf1818f",
};

export const URL_PATHNAME = {
  PROFILEPERSON: "/app/profile/SM009/profilePerson",
};

export const NEVER_DATE = new Date("01-01-2154");

export const FILTER_PERIOD_BY_REPORT = {
  YEAR_TO_DATE: "Year Todate",
  PROCESS_DATE: "ProcessDate",
};

export const REF_TABLE_NAME = {
  WorkerIDPJobPlanRequirementPlan: "WorkerIDPJobPlanRequirementPlan",
  WorkerIDPJobPlanRequirement: "WorkerIDPJobPlanRequirement",
  Tmabsencecorrection: "Tmabsencecorrection",
};

export const WORKLIST_STATUS = {
  IN_PROGRESS: "In Progress",
  NOT_STARTED: "Not Started",
  FINISHED: "Finished",
};

export const REPORT_FILE = {
  OFFBOARDING: "Reportingoffboarding",
};

export const ELIGIBILITY_FOR = {
  LATE_TYPE: "Late Type",
};

export const REGENERATE_SCOPE = {
  ALL: "All",
  WORKER: "Worker",
};

export const REGENERATE_SCOPE_OPTIONS = [
  { value: REGENERATE_SCOPE.ALL, label: "All Worker" },
  { value: REGENERATE_SCOPE.WORKER, label: "By Worker" },
];

// benbenefittype.CoverageLevel: one worker-owned balance shared by the worker and their dependants.
export const COVERAGE_LEVEL = {
  SHARED_DEPENDENT_AND_WORKER: "Shared Dependent and Worker",
};
